/* eslint-disable */
export default {
  noActiveCalls: '无使用中通话',
  currentCall: '当前通话',
  ringCall: '正在振铃通话',
  onHoldCall: '处于暂候状态的通话',
  otherDeviceCall: '我的其他设备上正在进行的通话',
  confirmation: '确认',
  confirmMergeToConference: '是否添加至电话会议？',
  mergeToConference: '合并',
  conferenceCall: '电话会议',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
